<template>
  <div>
    <div style="display: flex; align-items: center">
      <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 200px">
        {{ note || '-' }}
      </div>
      <div>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn flat icon color="primary" v-on="on" @click="editNoteDialogOpen = true">
              <em class="fa fa-pencil-alt" />
            </v-btn>
          </template>
          <span>แก้ไขหมายเหตุ</span>
        </v-tooltip>
      </div>
    </div>

    <v-dialog v-model="editNoteDialogOpen" width="350px" persistent>
      <v-card class="pa-3">
        <div class="form-control pb-2">
          <div class="mb-1">หมายเหตุ</div>

          <textarea v-model="input.note" rows="5" style="resize: vertical; height: auto"></textarea>
        </div>
        <div class="text-xs-center">
          <v-btn
            color="grey"
            outline
            @click="
              () => {
                editNoteDialogOpen = false
              }
            "
            >{{ $t('cancel') }}</v-btn
          >
          <v-btn color="primary" depressed @click="handleSaveNote">{{ $t('Save') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
export default {
  // components: {
  //   AutoresizeTextarea
  // },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      note: null,
      input: {
        note: ''
      },
      editNoteDialogOpen: false
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.note = this.value
        this.input.note = this.value
      }
    }
  },
  mounted() {
    this.note = this.value
    this.input.note = this.value
  },
  methods: {
    handleSaveNote() {
      this.$emit('onSaveNote', this.input.note)
      this.editNoteDialogOpen = false
      this.input.note = ''
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/EditNoteDialog.vue